<template>
    <div class="fixed inset-0 z-50 flex p-6 overflow-y-auto bg-smoke-light">
        <on-escape :execute="close">
            <slot />
        </on-escape>
    </div>
</template>

<script>
    export default {
        props: {
            isOpen: {
                type: Boolean,
                required: true
            }
        },
        methods: {
            close () {
                this.$emit('close', false)
            }
        }
    }
</script>
